import { render } from "./TheBBRActions.vue?vue&type=template&id=8aa98a94"
import script from "./TheBBRActions.vue?vue&type=script&lang=js"
export * from "./TheBBRActions.vue?vue&type=script&lang=js"
script.render = render

export default script